import React from 'react';
import { utils } from '../../utils';
import BoardSprite from "./BoardSprite"
import { emit } from '../Socket/game.Emitters';

const BoardTile = ( { textureCache, ...props } ) =>
{
  return (
    <BoardSprite
      textureCache={ textureCache }
      { ...props }
    />
  );
};

const BoardMeeple = ( { textureCache, anchorOffset = { x: 0, y: 0 }, useAlphaThreshold = false, ...props } ) =>
{
  const alphaThreshold = ( props.onClick && useAlphaThreshold ) ? 0.5 : undefined; // Only pixels with alpha > 0.5 are clickable

  return (
    <BoardSprite
      anchor={ { x: 0.5 + anchorOffset.x, y: 0.75 + anchorOffset.y } }
      textureCache={ textureCache }
      alphaThreshold={ alphaThreshold }
      { ...props }
    />
  );
};

class PixiMeeplePlacementInteractionHandler extends React.Component
{
  state = {
    currentMeeplePlacementHash: null,
    currentMeeplePlacementIndex: -1,
    placementResolvedForMoveWithNumTilesRemaining: null
  };

  onMeeplePlacementClick = ( tileHash, placementIndex ) =>
  {
    this.setState( {
      currentMeeplePlacementHash: tileHash,
      currentMeeplePlacementIndex: placementIndex
    } );
  }

  onMeeplePlacementCancelClick = () =>
  {
    this.clearMeepleTurnData();
  }

  onMeeplePlacementSkipped = () =>
  {
    this.clearMeepleTurnData( { placementResolvedForMoveWithNumTilesRemaining: this.props.numTilesRemaining } );
  }

  onMeeplePlacementConfirmClick = () =>
  {
    // Call to server to inform of placement decision
    emit.playerMeeplePlacement( { tileHash: this.state.currentMeeplePlacementHash, placementIndex: this.state.currentMeeplePlacementIndex, meepleType: 0 } );

    this.clearMeepleTurnData( { placementResolvedForMoveWithNumTilesRemaining: this.props.numTilesRemaining } );
  }

  clearMeepleTurnData = ( additionalStateDataToSet = {} ) =>
  {
    let stateData = { currentMeeplePlacementHash: null, currentMeeplePlacementIndex: -1, ...additionalStateDataToSet };

    this.setState( stateData );
  }

  render()
  {
    const {
      stageRenderData,
      textureCache,
      validMeeplePlacements,
      playerTeamColourID,
      numTilesRemaining
    } = this.props;

    const {
      currentMeeplePlacementHash,
      currentMeeplePlacementIndex,
      placementResolvedForMoveWithNumTilesRemaining
    } = this.state;

    const renderScale = stageRenderData.scale;

    let placementMeepleOptionSprites = [];
    let meepleInteractionContent = [];

    if( placementResolvedForMoveWithNumTilesRemaining !== numTilesRemaining )
    {

      if( currentMeeplePlacementHash
        && validMeeplePlacements[ currentMeeplePlacementHash ]
        && currentMeeplePlacementIndex >= 0
        && currentMeeplePlacementIndex < validMeeplePlacements[ currentMeeplePlacementHash ].length )
      {
        let tileCoords = utils.hashToCoord( currentMeeplePlacementHash );
        let currentPreviewMeeplePlacementData = validMeeplePlacements[ currentMeeplePlacementHash ][ currentMeeplePlacementIndex ];
        const localMeepleCoords = currentPreviewMeeplePlacementData.localMeepleCoords;
        let isFarmerPlacement = false;

        if( currentPreviewMeeplePlacementData.isFarmer )
        {
          isFarmerPlacement = true;
        }

        // Add meeple preview
        placementMeepleOptionSprites.push(

          <BoardMeeple
            key={ `meeple_preview_${currentMeeplePlacementHash}_${currentMeeplePlacementIndex}` }
            imageSrc={ utils.getAssetPath(`./meeples/Meeple - ${isFarmerPlacement ? 'Farmer' : 'Standard'} - ${playerTeamColourID}.png`) }
            renderScale={ renderScale }
            textureCache={ textureCache }
            x={ tileCoords.x + localMeepleCoords.x }
            y={ -1 * ( tileCoords.y + localMeepleCoords.y ) }
            anchorOffset={ isFarmerPlacement ? { x: -0.06, y: 0.12 } : { x: -0.0, y: 0.05 } }
          />
        );


        // Add the confirm button
        meepleInteractionContent.push(

          <BoardTile
            key="confirm button"
            imageSrc="./ui/button-tick.png"
            renderScale={ renderScale }
            x={ tileCoords.x + 0.7 }
            y={ ( -1 * tileCoords.y ) - 0.6 }
            textureCache={ textureCache }
            onClick={ () =>
            {
              // console.log("Confirmed placement");
              this.onMeeplePlacementConfirmClick();
            } }
          />
        );

        // Add the cancel button
        meepleInteractionContent.push(
          <BoardTile
            key="cancel button"
            imageSrc="./ui/button-cross.png"
            renderScale={ renderScale }
            x={ tileCoords.x - 0.7 }
            y={ ( -1 * tileCoords.y ) - 0.6 }
            textureCache={ textureCache }
            onClick={ () =>
            {
              // console.log("Cancel placement");
              this.onMeeplePlacementCancelClick();
            } }
          />
        );
      }


      for( let tileHash in validMeeplePlacements )
      {
        let tileCoords = utils.hashToCoord( tileHash );
        let meeplePlacements = validMeeplePlacements[ tileHash ];

        for( let idx = 0; idx < meeplePlacements.length; idx++ )
        {
          let localMeepleCoords = meeplePlacements[ idx ].localMeepleCoords;
          let isFarmerPlacement = false;

          if( meeplePlacements[ idx ].isFarmer )
          {
            isFarmerPlacement = true;
          }

          let outlineAlpha = 1;
          let onClickAction = () => { this.onMeeplePlacementClick( tileHash, idx ); };

          if( currentMeeplePlacementHash
            && currentMeeplePlacementHash === tileHash
            && currentMeeplePlacementIndex === idx )
          {
            outlineAlpha = 0;
            onClickAction = null;
          }

          placementMeepleOptionSprites.push(
            <BoardMeeple
              key={ "meepleOption" + placementMeepleOptionSprites.length }
              imageSrc={ utils.getAssetPath(`./meeples/Meeple - Outline - ${isFarmerPlacement ? 'Farmer' : 'Standing'}.png`) }
              renderScale={ renderScale }
              x={ tileCoords.x + localMeepleCoords.x }
              y={ -1 * ( tileCoords.y + localMeepleCoords.y ) }
              alpha={ outlineAlpha }
              textureCache={ textureCache }
              onClick={ onClickAction }
              useAlphaThreshold={ true } // Enable pixel-perfect alpha threshold detection
              anchorOffset={ isFarmerPlacement ? { x: -0.06, y: 0.22 } : { x: -0.0, y: 0.15 } }
            />
          );
        }
      }





    }

    // NOTE: Render any place meeple preview sprites first ( 'meepleInteractionContent' ), to avoid their larger sprite hit area getting in the
    // way of any close-by empty meeple placements

    return (
      <>
        { placementMeepleOptionSprites }
        { meepleInteractionContent }
      </>
    );
  }
}

export default PixiMeeplePlacementInteractionHandler;
